var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch"},[_c('div',{staticClass:"switch__content"},[_c('AllowWebCallSwitch',{staticClass:"switch__item--border",attrs:{"data":_vm.dataObject},on:{"update":_vm.updateDataObject}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }